export * from './register/register.component';
export * from './login/login.component';
export * from './created/account.created.component';
export * from './confirm/account.confirm.component';
export * from './recover/account.recover.component';
export * from './reset/account.reset.component';
export * from './logout/logout.component';



// WEBPACK FOOTER //
// ./src/components/account/index.ts